<template>
  <el-dialog
      custom-class="coupon"
      append-to-body
      :show-close="false"
      title=""
      :visible.sync="dialogFormVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false">
    <div class="header">
      <i class="el-icon-close" @click="closeDialog"></i>
      <img class="icon-coupon" :src="`${$g.imgPrefix}/img/home/coupon.png`">
      <img class="arrow" :src="`${$g.imgPrefix}/img/home/coupon-arrow.webp`">
      <div class="header-red"></div>
    </div>

    <div class="content">
      <div class="content-logo">
        <div class="content-img">
          <!--          <img :src="`${$g.imgPrefix}/img/header/logo.png`">-->
        </div>
      </div>
      <!-- 不要浪费这个折扣！-->
      <div class="content-text">{{ $t('home.nowastediscount') }}</div>
    </div>
    <!-- 折扣码-->
    <div class="discount">
      <div class="discount-box">
        <div :style="backgroundImageStyle" class="discount-item discount-autumn">
          <div class="discount-item-top">
            <!-- 百分比-->
            <div class="discount-item-top-left">
              <span class="discount-num">{{dataForm.discountratio}}%</span>
            </div>
            <!-- 折扣码-->
            <div class="discount-item-top-right">
              <div class="discount-description">
                <div>{{$t('friends.discountcode')}}:</div>
                <div class="discount-description-code">{{dataForm.discountcode}}</div>
              </div>
            </div>
          </div>
          <div class="divider-box">
            <div class="dash-line"></div>
          </div>
          <div class="info-box">
            <el-button
                v-clipboard:copy="dataForm.discountcode"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
                class="copybtn">{{$t('friends.copy')}}</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">

    </div>
  </el-dialog>
</template>

<script>
import {
  MessageError,
  MessageSuccess,
  formatObj,
  isEmpty
} from "@/util/util";

import {
  getCouponInfo
} from "@/request/requests";
export default {
  name: "coupon",
  data() {
    return {
      dialogFormVisible: false,
      discountBg: require("../assets/img/common/autumn.webp"),
      dataForm:{
        //折扣码
        discountcode:'',
        //折扣率
        discountratio:''
      }

    }
  },
  computed:{
    backgroundImageStyle() {
      return {
        backgroundImage: `url(${this.$g.imgPrefix}/img/common/autumn.webp)`
      };
    }
  },
  methods: {
    init() {
      this.dialogFormVisible = true;
      this.getCouponInfo();
    },
    async getCouponInfo(){
      let res = await getCouponInfo();
      if (res.status == "200") {
        let formattedData = formatObj(res.data);
        if(!isEmpty(formattedData.discountratio)){
          formattedData.discountratio = parseFloat(formattedData.discountratio)*100;
        }else{
          formattedData.discountratio = 0;
        }
        this.dataForm = formattedData;
      } else {
        MessageError(res.msg);
      }
    },
    onCopy(e){
      MessageSuccess(this.$t('friends.copysuccessfully'));
      console.log('copy Success:'+e.text);
    },
    onError(e){
      MessageError(this.$t('friends.copyfailed'));
      console.log('copy Failed:'+e.text);
    },
    closeDialog() {
      this.dialogFormVisible = false;
      this.$emit('closeCoupon');
    }
  }
}
</script>
<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

::v-deep .coupon {
  margin-top: 0 !important;
  width: 500px !important;
  background-color: #df413d;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  @media (max-width: 576.98px) {
    width: calc(100% - 25px)!important;
  }

  .el-dialog__header {
    display: none !important;
  }

  .el-dialog__body {
    padding: 0 !important;
  }

  .header {
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    background-color: #df413d;
    height: 200px;
    position: relative;
    @media (max-width: 576px) {
      height: 137px;
    }

    .icon-coupon {
      position: absolute;
      top: -137px;
      left: 13%;
      transform: rotate(71deg);
      width: 372px;
      @media (max-width: 576px) {
        width: 251px;
        top: -97px;
        left: 14%;
        transform: rotate(75deg);
      }
    }

    .arrow {
      width: 100%;
      position: absolute;
      top: 66%;
      @media (max-width: 576px) {
        top: 54%;
      }
    }

    &-red {
      background-color: #ef534f;
      width: 100%;
      height: 70px;
      position: absolute;
      bottom: -28px;
      @media (max-width: 576px) {
        bottom: -23px;
      }
    }

    .el-icon-close {
      cursor: pointer;
      position: absolute;
      right: 13px;
      top: 14px;
      font-size: 20px;
      font-weight: bold;
      color: white;
      z-index: 99;
    }
  }

  .content {
    background-color: #ef534f;
    position: relative;

    &-logo {
      border-radius: 50%;
      width: 114px;
      height: 114px;
      position: absolute;
      top: -79px;
      left: 50%;
      transform: translateX(-50%);
      @media (max-width: 576px) {
        width: 77px;
        height: 77px;
      }
    }

    &-img {
      border-radius: 50%;
      height: 82px;
      width: 82px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      @media (max-width: 576px) {
        width: 54px;
        height: 54px;
      }

      img {
        width: 66px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        @media (max-width: 576.98px) {
          width: 45px;
        }
      }
    }

    &-text {
      color: #feeecc;
      font-size: 20px;
      font-weight: 700;
      line-height: 24px;
      text-align: center;
      width: 100%;
      padding-bottom:30px;
      @media (max-width: 576px) {
        font-size: 16px;
        top: 18px;
        padding-bottom:16px;
      }
    }
  }

  .footer{
    background: #ef534f;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    height: 80px;
    overflow: hidden;
    width: 100%;
  }

  .discount {
    background: #ef534f;
    width: 100%;
    margin-top: -2px;
    min-height:100px;
    @media (max-width:576.98px) {
      min-height:68px;
    }
    &-box{
      max-height: 312px;
      overflow-y: scroll;
      padding: 16px 11px 16px 20px;
    }
    &-item{
      border-radius: 16px;
      margin-bottom: 16px;
      width: 100%;
      &-top{
        align-items: center;
        display: flex;
        justify-content: space-between;
        padding: 24px 24px;
        width: 100%;
        &-left{
          color: #000000;
          width: 100px;
          @media (max-width:576.98px) {
            width:80px;
          }
        }
        &-right{
          align-items: flex-end;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width:calc(100% - 120px);
          @media (max-width:576.98px) {
            width:calc(100% - 90px);
          }
        }

      }

    }
    &-num{
      font-size: 24px;
      font-weight: 700;
      line-height: 28px;
      @media (max-width:576.98px) {
        font-size:18px;
      }
    }
    &-description{
      color:#000000;
      font-size:17px;
      font-weight: bold;
      display:flex;
      text-align: right;
      @media (max-width:576.98px) {
        font-size:14px;
      }
      &-code{
        margin-left:10px;
        max-width: 167px;
      }
    }
    &-autumn{
      //background-image: url(../assets/img/common/autumn.webp);
      background-position: 50%;
      background-size: cover;
    }
    .divider-box{
      align-items: center;
      display: flex;
      justify-content: space-between;
      margin: 0 12px;
    }
    .dash-line{
      border-top: 1px dashed #69361a !important;
      height: 1px;
      flex:1;
    }
    .info{
      &-box{
        text-align: right;
        padding: 10px 20px;
      }

    }

  }

}
</style>
<style lang="scss">
.el-button.copybtn{
  padding:12px 20px!important;
  background: #84F0AA!important;
  width:20% !important;
  border-radius: 34px!important;
  @media (max-width:576.98px) {
    border-radius:20px!important;
    width:76px!important;
    font-size:12px!important;
  }
}
</style>